export function normalizeSearchText(raw: string): string {
    if (raw == null) return '';

    const text = raw.replace(/\u00A0/g, ' ');
    const trimmed = text.trim();

    if (!trimmed) return text;

    const numericLikeRegex = /^[\s()+\-−€$£¥₴]*[\d][\d\s.,\-−–€$£¥₴A-Za-z%]*[)\s]*$/u;

    if (!numericLikeRegex.test(trimmed)) {
        return text.replace(/\s{2,}/g, ' ');
    }

    let s = trimmed;
    let isNegative = false;

    if (s.startsWith('(') && s.endsWith(')')) {
        isNegative = true;
        s = s.slice(1, -1).trim();
    }

    const signMatch = s.match(/^[+\-−\s]+/u);

    if (signMatch) {
        if (signMatch[0].includes('-') || signMatch[0].includes('−')) {
            isNegative = true;
        }

        s = s.slice(signMatch[0].length).trim();
    }

    s = s.replace(/[€$£¥₴]/g, '');
    s = s.replace(/\b(EUR|USD|GBP|UAH|JPY)\b/gi, '');
    s = s.replace(/[A-Za-z%]+/g, '');
    s = s.replace(/([,.])\s*[–\-]\s*$/, '$100');
    s = s.trim();
    s = s.replace(/\s+/g, '');

    const commaCount = (s.match(/,/g) || []).length;
    const dotCount = (s.match(/\./g) || []).length;

    if (commaCount === 0 && dotCount === 0) {
        // plain int
    } else if (commaCount === 1 && dotCount === 0) {
        s = s.replace(',', '.');
    } else if (commaCount === 0 && dotCount === 1) {
        // ok
    } else if (commaCount >= 1 && dotCount >= 1) {
        const lastComma = s.lastIndexOf(',');
        const lastDot = s.lastIndexOf('.');

        if (lastComma > lastDot) {
            s = s.replace(/\./g, '').replace(',', '.');
        } else {
            s = s.replace(/,/g, '');
        }
    } else if (commaCount > 1) {
        const lastComma = s.lastIndexOf(',');
        const intPart = s.slice(0, lastComma).replace(/,/g, '');
        const fracPart = s.slice(lastComma + 1);

        s = `${intPart}.${fracPart}`;
    } else if (dotCount > 1) {
        s = s.replace(/\./g, '');
    }

    s = s.replace(/[^\d.]/g, '');

    if (!s || s === '.') return '';

    const dotIdx = s.indexOf('.');
    let intStr = dotIdx === -1 ? s : s.slice(0, dotIdx);
    const fracStr = dotIdx === -1 ? '' : s.slice(dotIdx + 1);

    intStr = String(parseInt(intStr || '0', 10));
    s = fracStr !== '' ? `${intStr}.${fracStr}` : intStr;

    if (isNegative) {
        const num = parseFloat(s);

        if (num !== 0) {
            s = '-' + s;
        }
    }

    return s;
}
